(function (window, document, $) {

    $(document).ready(function () {

        $('.qty-increment, .qty-decrement').on('click', function(e) {
            const isNegative = $(e.target).closest('.qty-decrement').is('.qty-decrement');
            const input = $(e.target).closest('.qty-input-container').find('input');
            if (input.is('input')) {
            input[0][isNegative ? 'stepDown' : 'stepUp']()
            }
        });
    });

}(window, document, jQuery));